module.exports = __webpack_public_path__ + "img/useful_hero_md.f348a841.png";